import React, {Component} from 'react'
import Alert from "react-bootstrap/Alert";
import jwtClient from "../JwtClient";
import FormDelimiter from "./FormDelimiter";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputGroup from "react-bootstrap/InputGroup";
import Prepend from "./Prepend";
import {Prepend as PrependRU} from "./RUnew/Prepend";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Input from "./Input";
import InputMask from "react-input-mask";
import {
    phoneReRU,
    RUSSIA_CODE,
    validateField,
    validatorRU
} from "../Validation";
import {DeliverTo} from "./RU/Address";
import CountryList from "../CountryList";
import Delimiter from "./RUnew/Delimiter";
import ConsigneeAddress from "./RUnew/Address";

export default class UpdatePackage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pkg: {},
        }
    }

    render() {
        const {
            pkg,
        } = this.state;
        if (!!Object.keys(pkg).length) {
            if (pkg.customs_declaration.country_of_destination === 'UA') {
                return (
                    <div>
                        {!!this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
                        {<UpdatePackageUA pkg={this.state.pkg} history={this.props.history}/>}
                    </div>
                )
            } else if (pkg.customs_declaration.country_of_destination === 'RU') {
                return (
                    <div>
                        {!!this.state.error && <Alert variant="danger">{this.state.error}</Alert>}
                        {<UpdatePackageRU packageID={this.props.match.params.id}/>}
                    </div>
                )
            }
        }
        return null
    }

    componentDidMount() {
        jwtClient.get(`/api/v1/package/${this.props.match.params.id}`)
            .then((response) => {
                this.setState({
                    pkg: response.data,
                });
            })
    }
}

class UpdatePackageRU extends React.Component {
    regionsUrl = '/api/v1/address/bxb/regions'
    lmsCode = 'BXB'

    constructor(props) {
        super(props);

        this.state = {
            formErr: '',
            isSubmitting: false,

            code: '',
            referenceNumber: '',

            consigneeDisabled: true,
            phone: '', phoneErr: '',
            phoneDisabled: false,
            name: '', nameErr: '',
            middlename: '', middlenameErr: '', // Only for Russian citizenship
            surname: '', surnameErr: '',
            email: '', emailErr: '',

            individualTaxpayerNumber: '', individualTaxpayerNumberErr: '', // Only for Russian citizenship
            passportCountry: '',
            passportSeries: '', passportSeriesErr: '', // Only for Russian citizenship
            passportNumber: '', passportNumberErr: '',
            passportYear: '', passportYearErr: '',
            passportMonth: '', passportMonthErr: '',
            passportDay: '', passportDayErr: '',
            passportIssuedBy: '', passportIssuedByErr: '',

            items: [],
            total: 0,

            // Switches from BXB pickup point to Consignee address
            deliverTo: DeliverTo.door,

            // BXB pickup point address
            bxbRegion: '', bxbRegionErr: '',
            bxbRegionID: '',
            bxbCity: '', bxbCityErr: '',
            bxbCityID: '',
            bxbStreet: '', bxbStreetErr: '',
            bxbStreetID: '',  // pickup point id
            bxbRegions: [], // [{"id":"2635056679","name":"Sankt-Peterburg"}, ...]
            bxbCities: [],
            bxbStreets: [],

            // Consignee address
            zip: '', zipErr: '',
            region: '', regionErr: '',
            city: '', cityErr: '',
            street: '', streetErr: '',
            house: '', houseErr: '',
            corpus: '', corpusErr: '',
            apartment: '', apartmentErr: '',
        }
    }

    componentDidMount() {
        this.loadPackage(this.props.packageID)

        if (this.state.deliverTo === DeliverTo.door) {
            return
        }
        // TODO bxb might change address of pickup, in that case it's better to check
        // if bxbRegionID from backend database is present in bxb response. If not then
        // clear all bxb address fields in the form (?)
        this.loadRegions()
            .then(()=> this.loadCities(this.state.bxbRegionID))
            .then(()=> this.loadStreets(this.state.bxbCityID))
    }

    loadPackage = (packageID) => {
        jwtClient.get(`/api/v1/package/${packageID}`)
            .then((response) => {
                const pkg = response.data;
                const passportIssuedAt = pkg.customs_declaration.consignee_personal_data.passport_issued_at.split('-');
                const consignee = pkg.customs_declaration.consignee_personal_data;
                const address = pkg.customs_declaration.consignee_address;
                let items = [];
                let total = 0;
                for (let i of pkg.customs_declaration.items) {
                    let item = {
                        link: i.link, linkErr: '',
                        description: i.description, descriptionErr: '',
                        quantity: i.quantity, quantityErr: '',
                        price: i.price, priceErr: '',
                    }
                    total += parseFloat((i.price * i.quantity).toFixed(2));
                    items.push(item)
                }
                total = total.toFixed(2);
                const toDoor = address.deliver_to === DeliverTo.door
                const toPickupPoint = address.deliver_to === DeliverTo.pickupPoint

                this.setState({
                    code: pkg.code,
                    referenceNumber: pkg.track,
                    consigneeDisabled: false,
                    phone: consignee.phone, phoneErr: '',
                    phoneDisabled: false,
                    name: consignee.name, nameErr: '',
                    middlename: consignee.middlename, middlenameErr: '', // Only for Russian citizenship
                    surname: consignee.surname, surnameErr: '',
                    email: consignee.email, emailErr: '',

                    individualTaxpayerNumber: consignee.individual_taxpayer_number, individualTaxpayerNumberErr: '', // Only for Russian citizenship
                    passportCountry: consignee.passport_country,
                    passportSeries: consignee.passport_series, passportSeriesErr: '', // Only for Russian citizenship
                    passportNumber: consignee.passport_number, passportNumberErr: '',
                    passportYear: passportIssuedAt[0], passportYearErr: '',
                    passportMonth: passportIssuedAt[1], passportMonthErr: '',
                    passportDay: passportIssuedAt[2], passportDayErr: '',
                    passportIssuedBy: consignee.passport_issued_by, passportIssuedByErr: '',

                    items: items,
                    total: total,

                    // Switches from BXB pickup point to Consignee address
                    deliverTo: address.deliver_to,

                    // BXB pickup point address
                    bxbRegion: toPickupPoint ? address.region.label : '', bxbRegionErr: '',
                    bxbRegionID: toPickupPoint ? address.region.value : '',
                    bxbCity: toPickupPoint ? address.city.label : '', bxbCityErr: '',
                    bxbCityID: toPickupPoint ? address.city.value : '',
                    bxbStreet: toPickupPoint ? address.street.label : '', bxbStreetErr: '',
                    bxbStreetID: toPickupPoint ? address.street.value : '',  // pickup point id
                    bxbRegions: [], // [{"id":"2635056679","name":"Sankt-Peterburg"}, ...]
                    bxbCities: [],
                    bxbStreets: [],

                    // Consignee address
                    zip: toDoor ? address.zip : '', zipErr: '',
                    region: toDoor ? address.region : '', regionErr: '',
                    city: toDoor ? address.city : '', cityErr: '',
                    street: toDoor ? address.street : '', streetErr: '',
                    house: toDoor ? address.house : '', houseErr: '',
                    corpus: toDoor ? address.corpus : '', corpusErr: '',
                    apartment: toDoor ? address.apartment : '', apartmentErr: '',
                })
            })
    }

    render() {
        if (!this.state.referenceNumber) {
            return null
        }
        return (
            <div>
                <h2 className="mt-3">Update Package "{this.state.code}"</h2>
                {!!this.state.formErr && <div className="alert alert-danger">{this.state.formErr}</div>}
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Reference/order number"/>
                                    <input className="form-control" placeholder={this.state.referenceNumber} disabled/>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Last Mile Service"/>
                                    <input className="form-control" placeholder="Boxberry" disabled/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Delimiter text="CONSIGNEE"/>

                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <small>
                                                Phone <div
                                                className={this.state.phoneDisabled ? "spinner-border spinner-border-sm" : "spinner-border spinner-border-sm invisible"}> </div>
                                            </small>
                                        </span>
                                    </div>
                                    <InputMask
                                        className={this.state.phoneErr ? "form-control is-invalid" : "form-control"}
                                        name="phone"
                                        value={this.state.phone}
                                        disabled={this.state.phoneDisabled}
                                        mask="\+7 999 999-99-99"
                                        onChange={e => {
                                            const [v, fieldName] = [e.target.value, e.target.name];
                                            const fieldNameErr = fieldName + 'Err'
                                            const err = validateField(validatorRU, fieldName, v)
                                            this.setState({
                                                [fieldName]: v,
                                                [fieldNameErr]: err,
                                            })
                                        }}
                                    />
                                    <div className="invalid-feedback">{this.state.phoneErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Email"/>
                                    <input
                                        value={this.state.email}
                                        name="email"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.emailErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.emailErr}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-4">
                                <div className="input-group">
                                    <PrependRU value="Name"/>
                                    <input
                                        value={this.state.name}
                                        name="name"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.nameErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.nameErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-4">
                                <div className="input-group">
                                    <PrependRU value="Middlename"/>
                                    <input
                                        value={this.state.middlename}
                                        name="middlename"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.middlenameErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled || this.state.passportCountry !== RUSSIA_CODE}
                                    />
                                    <div className="invalid-feedback">{this.state.middlenameErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-4">
                                <div className="input-group">
                                    <PrependRU value="Surname"/>
                                    <input
                                        value={this.state.surname}
                                        name="surname"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.surnameErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.surnameErr}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Delimiter text="PASSPORT"/>

                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Country"/>
                                    <select
                                        value={this.state.passportCountry}
                                        className="form-control"
                                        onChange={e => {
                                            const v = e.target.value
                                            if (v === RUSSIA_CODE) {
                                                this.setState({passportCountry: v})
                                            } else {
                                                this.setState({
                                                    passportCountry: v,
                                                    middlename: '',
                                                    middlenameErr: '',
                                                    individualTaxpayerNumber: '',
                                                    individualTaxpayerNumberErr: '',
                                                    passportSeries: '',
                                                    passportSeriesErr: '',
                                                    passportNumberErr: '',
                                                })
                                            }
                                        }}
                                        disabled={this.state.consigneeDisabled}
                                    >
                                        {
                                            CountryList.map((v, i) => {
                                                return (
                                                    <option key={i} value={v['country-code']}>
                                                        {v['name']}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Individual Taxpayer Number"/>
                                    <input
                                        value={this.state.individualTaxpayerNumber}
                                        name="individualTaxpayerNumber"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.individualTaxpayerNumberErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled || this.state.passportCountry !== RUSSIA_CODE}
                                    />
                                    <div className="invalid-feedback">{this.state.individualTaxpayerNumberErr}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Series"/>
                                    <input
                                        value={this.state.passportSeries}
                                        name="passportSeries"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.passportSeriesErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled || this.state.passportCountry !== RUSSIA_CODE}
                                    />
                                    <div className="invalid-feedback">{this.state.passportSeriesErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Number"/>
                                    <input
                                        value={this.state.passportNumber}
                                        name="passportNumber"
                                        onChange={e => {
                                            this.handleChangeBlur(e, this.state.passportCountry)
                                        }}
                                        onBlur={e => {
                                            this.handleChangeBlur(e, this.state.passportCountry)
                                        }}
                                        className={this.state.passportNumberErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.passportNumberErr}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-2">
                                <div className="input-group">
                                    <PrependRU value="Day"/>
                                    <input
                                        value={this.state.passportDay}
                                        name="passportDay"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.passportDayErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.passportDayErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-2">
                                <div className="input-group">
                                    <PrependRU value="Month"/>
                                    <input
                                        value={this.state.passportMonth}
                                        name="passportMonth"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.passportMonthErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.passportMonthErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-2">
                                <div className="input-group">
                                    <PrependRU value="Year"/>
                                    <input
                                        value={this.state.passportYear}
                                        name="passportYear"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.passportYearErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.passportYearErr}</div>
                                </div>
                            </div>

                            <div className="col-sm-6">
                                <div className="input-group">
                                    <PrependRU value="Issued By"/>
                                    <input
                                        value={this.state.passportIssuedBy}
                                        name="passportIssuedBy"
                                        onChange={this.handleChangeBlur}
                                        onBlur={this.handleChangeBlur}
                                        className={this.state.passportIssuedByErr ? "form-control is-invalid" : "form-control"}
                                        disabled={this.state.consigneeDisabled}
                                    />
                                    <div className="invalid-feedback">{this.state.passportIssuedByErr}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Delimiter text="ADDRESS"/>

                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            id={DeliverTo.door}
                            name="deliverTo"
                            value={DeliverTo.door}
                            checked={this.state.deliverTo === DeliverTo.door}
                            onChange={_ => this.setState({deliverTo: DeliverTo.door})}
                        />
                        <label className="form-check-label" htmlFor={DeliverTo.door}>Courier Delivery</label>
                    </div>

                    <div className="form-check form-check-inline">
                        <input
                            className="form-check-input"
                            type="radio"
                            id={DeliverTo.pickupPoint}
                            name="deliverTo"
                            value={DeliverTo.pickupPoint}
                            checked={this.state.deliverTo === DeliverTo.pickupPoint}
                            onChange={_ => {
                                this.setState({deliverTo: DeliverTo.pickupPoint}, () => {
                                    this.loadRegions()
                                })
                            }}
                        />
                        <label className="form-check-label" htmlFor={DeliverTo.pickupPoint}>Pickup Point</label>
                    </div>

                    {
                        this.state.deliverTo === DeliverTo.door ?
                            <ConsigneeAddress
                                zip={this.state.zip} zipErr={this.state.zipErr}
                                region={this.state.region} regionErr={this.state.regionErr}
                                city={this.state.city} cityErr={this.state.cityErr}
                                street={this.state.street} streetErr={this.state.streetErr}
                                house={this.state.house} houseErr={this.state.houseErr}
                                corpus={this.state.corpus} corpusErr={this.state.corpusErr}
                                apartment={this.state.apartment} apartmentErr={this.state.apartmentErr}
                                handleChangeBlur={this.handleChangeBlur}
                            /> :
                            <div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <small>
                                                            Regions <div
                                                            className={this.state.bxbRegions.length === 0 ? "spinner-border spinner-border-sm" : "spinner-border spinner-border-sm invisible"}> </div>
                                                        </small>
                                                    </span>
                                                </div>
                                                <select
                                                    value={this.state.bxbRegionID}
                                                    onChange={e => {
                                                        const regionID = e.target.value
                                                        const region = e.target.options[e.target.selectedIndex].text
                                                        this.setState({
                                                            bxbRegion: region, bxbRegionErr: '',
                                                            bxbRegionID: regionID,
                                                            bxbCities: [],
                                                            bxbCity: '', bxbCityErr: '',
                                                            bxbCityID: '',
                                                            bxbStreets: [],
                                                            bxbStreet: '', bxbStreetErr: '',
                                                            bxbStreetID: '',
                                                        }, () => this.loadCities(regionID))
                                                    }}
                                                    className={this.state.bxbRegionErr ? "form-control is-invalid" : "form-control"}
                                                    disabled={this.state.bxbRegions.length === 0}
                                                >
                                                    <option></option>
                                                    {
                                                        this.state.bxbRegions.map((v, i) => {
                                                            return (
                                                                <option key={i} value={v['id']}>{v['name']}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div className="invalid-feedback">{this.state.bxbRegionErr}</div>
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <small>
                                                            Cities <div
                                                            className={this.state.bxbRegion && this.state.bxbCities.length === 0 ? "spinner-border spinner-border-sm" : "spinner-border spinner-border-sm invisible"}> </div>
                                                        </small>
                                                    </span>
                                                </div>
                                                <select
                                                    value={this.state.bxbCityID}
                                                    onChange={e => {
                                                        const cityID = e.target.value
                                                        const city = e.target.options[e.target.selectedIndex].text
                                                        this.setState({
                                                            bxbCity: city, bxbCityErr: '',
                                                            bxbCityID: cityID,
                                                            bxbStreets: [],
                                                            bxbStreet: '', bxbStreetErr: '',
                                                            bxbStreetID: '',
                                                        }, () => this.loadStreets(cityID))
                                                    }}
                                                    className={this.state.bxbCityErr ? "form-control is-invalid" : "form-control"}
                                                    disabled={this.state.bxbRegions.length === 0 || this.state.bxbCities.length === 0}
                                                >
                                                    <option></option>
                                                    {
                                                        this.state.bxbCities.map((v, i) => {
                                                            return (
                                                                <option key={i} value={v['id']}>{v['name']}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div className="invalid-feedback">{this.state.bxbCityErr}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <small>
                                                            Streets <div
                                                            className={this.state.bxbCity && this.state.bxbStreets.length === 0 ? "spinner-border spinner-border-sm" : "spinner-border spinner-border-sm invisible"}> </div>
                                                        </small>
                                                    </span>
                                                </div>
                                                <select
                                                    value={this.state.bxbStreetID}
                                                    onChange={e => {
                                                        const streetID = e.target.value
                                                        const street = e.target.options[e.target.selectedIndex].text
                                                        this.setState({
                                                            bxbStreet: street, bxbStreetErr: '',
                                                            bxbStreetID: streetID,
                                                        })
                                                    }}
                                                    className={this.state.bxbStreetErr ? "form-control is-invalid" : "form-control"}
                                                    disabled={this.state.bxbRegions.length === 0 || this.state.bxbStreets.length === 0}
                                                >
                                                    <option></option>
                                                    {
                                                        this.state.bxbStreets.map((v, i) => {
                                                            return (
                                                                <option
                                                                    key={i}
                                                                    value={v['id']}
                                                                >
                                                                    {v['name'] ? v['name'] : v['id']}
                                                                </option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <div className="invalid-feedback">{this.state.bxbStreetErr}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                    }

                    <Delimiter text="ITEMS"/>

                    <ol>
                        {this.state.items.map((item, index) => {
                            return (
                                <li key={index}>

                                    <div className="form-group">
                                        <div className="input-group">
                                            <PrependRU value="Link"/>
                                            <input
                                                value={item.link}
                                                name="link"
                                                onChange={e => this.handleChangeBlurItem(e, index)}
                                                onBlur={e => this.handleChangeBlurItem(e, index)}
                                                className={item.linkErr ? "form-control is-invalid" : "form-control"}
                                            />
                                            <div className="invalid-feedback">{item.linkErr}</div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="input-group">
                                            <PrependRU value="Description"/>
                                            <input
                                                value={item.description}
                                                name="description"
                                                onChange={e => this.handleChangeBlurItem(e, index)}
                                                onBlur={e => this.handleChangeBlurItem(e, index)}
                                                className={item.descriptionErr ? "form-control is-invalid" : "form-control"}
                                            />
                                            <div className="invalid-feedback">{item.descriptionErr}</div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <div className="row">

                                            <div className="col-sm-4">
                                                <div className="input-group">
                                                    <PrependRU value="Quantity"/>
                                                    <input
                                                        value={item.quantity}
                                                        type="number"
                                                        name="quantity"
                                                        onChange={e => this.handleChangeBlurItem(e, index)}
                                                        onBlur={e => this.handleChangeBlurItem(e, index)}
                                                        className={item.quantityErr ? "form-control is-invalid" : "form-control"}
                                                    />
                                                    <div className="invalid-feedback">{item.quantityErr}</div>
                                                </div>
                                            </div>

                                            <div className="col-sm-4">
                                                <div className="input-group">
                                                    <PrependRU value="Price"/>
                                                    <input
                                                        value={item.price}
                                                        type="number"
                                                        step="0.01"
                                                        name="price"
                                                        onChange={e => this.handleChangeBlurItem(e, index)}
                                                        onBlur={e => this.handleChangeBlurItem(e, index)}
                                                        onFocus={e => e.target.select()}
                                                        className={item.priceErr ? "form-control is-invalid" : "form-control"}
                                                    />
                                                    <div className="invalid-feedback">{item.priceErr}</div>
                                                </div>
                                            </div>

                                            <div className="col-sm-3">
                                                <div className="input-group">
                                                    <PrependRU value="Subtotal"/>
                                                    <input
                                                        readOnly
                                                        value={(item.price * item.quantity).toFixed(2)}
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-sm-1">
                                                <button
                                                    title="Remove item"
                                                    disabled={this.state.items.length === 1}
                                                    className="btn btn-danger"
                                                    onClick={e => {
                                                        e.preventDefault()
                                                        this.setState((prevState) => {
                                                            let items = [...prevState.items]
                                                            items.splice(index, 1)
                                                            return {items: items}
                                                        })
                                                    }}
                                                >
                                                    <span className="font-weight-bold">X</span>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </ol>

                    <hr/>
                    <div className="form-group">
                        <div className="row">

                            <div className="col-sm-8">
                                <button
                                    className="btn btn-success mr-3"
                                    onClick={e => {
                                        e.preventDefault()
                                        this.setState((prevState) => {
                                            const items = [...prevState.items, {
                                                link: '',
                                                linkErr: '',
                                                description: '',
                                                descriptionErr: '',
                                                quantity: 1,
                                                quantityErr: '',
                                                price: 0.00,
                                                priceErr: '',
                                            }]
                                            return {items: items}
                                        })
                                    }}
                                >
                                    New item
                                </button>

                            </div>

                            <div className="col-sm-4">
                                <div className="input-group">
                                    <PrependRU value="Total"/>
                                    <input
                                        readOnly
                                        value={this.calcTotal()}
                                        className="form-control"
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    <br/>

                    <div className="form-group">
                        <div className="row">

                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary"
                                        disabled={this.state.isSubmitting}> Submit
                                </button>
                            </div>

                            <div className="col-sm-2">
                                <a className="btn btn-danger" href="/">Cancel</a>
                            </div>

                        </div>
                    </div>

                </form>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.phone !== this.state.phone) {
            if (phoneReRU.test(this.state.phone)) {
                this.setState({
                    phoneDisabled: true,
                    consigneeDisabled: true,
                }, () => {
                    this.loadConsignee(this.state.phone)
                })
            }
        }
    }

    loadRegions = () => {
        return jwtClient.get(this.regionsUrl)
            .then((response) => {
                this.setState({bxbRegions: this.sortAddressOptions(response.data)});
            })
            .catch(err => {
                this.setState({bxbRegionErr: 'failed to load'})
            })
    }

    loadCities = regionID => {
        return jwtClient.get(this.regionsUrl, {params: {region_id: regionID}})
            .then((response) => {
                this.setState({bxbCities: this.sortAddressOptions(response.data)});
            })
            .catch(err => {
                this.setState({bxbCityErr: 'failed to load'})
            })
    };

    loadStreets = cityID => {
        return jwtClient.get(this.regionsUrl, {params: {city_id: cityID}})
            .then((response) => {
                this.setState({bxbStreets: this.sortAddressOptions(response.data)});
            })
            .catch(err => {
                this.setState({bxbStreetErr: 'failed to load'})
            })

    };

    sortAddressOptions = data => {
        data.sort(function (o1, o2) {
            if (o1['name'] > o2['name']) {
                return 1;
            } else if (o1['name'] < o2['name']) {
                return -1;
            }
            return 0;
        });
        return data;
    };

    handleChangeBlur = (e, ...options) => {
        const [v, fieldName] = [e.target.value, e.target.name];
        const fieldNameErr = fieldName + 'Err'
        const err = validateField(validatorRU, fieldName, v, ...options)
        this.setState({
            [fieldName]: v,
            [fieldNameErr]: err ? err : '',
        })
    }

    handleChangeBlurItem = (e, index) => {
        const [v, fieldName] = [e.target.value, e.target.name];
        const fieldNameErr = fieldName + 'Err'
        const err = validateField(validatorRU, fieldName, v)
        this.setState((prevState) => {
            let newItem = {...prevState.items[index]}
            newItem[fieldName] = v
            newItem[fieldNameErr] = err ? err : ''
            let newItems = [...prevState.items]
            newItems[index] = newItem
            return {items: newItems}
        })
    }

    loadConsignee = (phone) => {
        jwtClient.get(`/api/v1/consignee/phone/${phone}`)
            .then(response => {
                const d = response.data
                const passportIssuedAt = d.passport_issued_at.split('-');
                const consigneeID = d.id
                this.setState({
                    formErr: '',
                    phoneDisabled: false,
                    consigneeDisabled: false,

                    consigneeID: consigneeID,
                    name: d.name, nameErr: '',
                    middlename: d.middlename ? d.middlename : '', middlenameErr: '',
                    surname: d.surname, surnameErr: '',
                    email: d.email, emailErr: '',
                    passportCountry: d.passport_country ? d.passport_country : RUSSIA_CODE,
                    passportSeries: d.passport_series ? d.passport_series : '', passportSeriesErr: '',
                    passportNumber: d.passport_number, passportNumberErr: '',
                    passportYear: passportIssuedAt[0], passportYearErr: '',
                    passportMonth: passportIssuedAt[1], passportMonthErr: '',
                    passportDay: passportIssuedAt[2], passportDayErr: '',
                    passportIssuedBy: d.passport_issued_by, passportIssuedByErr: '',
                    individualTaxpayerNumber: d.individual_taxpayer_number ? d.individual_taxpayer_number : '',
                    individualTaxpayerNumberErr: '',
                }, () => this.loadAddress(consigneeID))
            })
            .catch(error => {
                if (error.response && error.response.status === 404) {
                    this.setState({
                        formErr: '',
                        phoneDisabled: false,
                        consigneeDisabled: false,

                        name: '', nameErr: '',
                        middlename: '', middlenameErr: '',
                        surname: '', surnameErr: '',
                        email: '', emailErr: '',
                        passportCountry: RUSSIA_CODE,
                        passportSeries: '', passportSeriesErr: '',
                        passportNumber: '', passportNumberErr: '',
                        passportYear: '', passportYearErr: '',
                        passportMonth: '', passportMonthErr: '',
                        passportDay: '', passportDayErr: '',
                        passportIssuedBy: '', passportIssuedByErr: '',
                        individualTaxpayerNumber: '', individualTaxpayerNumberErr: '',
                    })
                } else {
                    this.setState({
                        formErr: 'The service is temporary unavailable! Contact the administrators to resolve the issue!'
                    })
                }
            })
    }

    loadAddress = (consigneeID) => {
        let url = `/api/v1/consignee/${consigneeID}/last-delivered-address/${this.lmsCode}`
        jwtClient.get(url)
            .then(response => {
                let doorFound = false
                let pickupFound = false
                for (let i of response.data) {
                    if (i.deliver_to === DeliverTo.door && !doorFound) {
                        doorFound = true
                        this.setState({
                            zip: i.zip, zipErr: '',
                            region: i.region, regionErr: '',
                            city: i.city, cityErr: '',
                            street: i.street, streetErr: '',
                            house: i.house, houseErr: '',
                            corpus: i.corpus, corpusErr: '',
                            apartment: i.apartment, apartmentErr: '',
                            deliverTo: DeliverTo.door,
                        })
                    }
                    if (i.deliver_to === DeliverTo.pickupPoint && !pickupFound) {
                        pickupFound = true
                        const bxbRegion = i['region']['label']
                        const bxbRegionID = i['region']['value']
                        const bxbCity = i['city']['label']
                        const bxbCityID = i['city']['value']
                        const bxbStreet = i['street']['label']
                        const bxbStreetID = i['street']['value']
                        jwtClient.get(this.regionsUrl)
                            .then((response) => {
                                this.setState({
                                    bxbRegions: this.sortAddressOptions(response.data),
                                    bxbRegion: bxbRegion, bxbRegionErr: '',
                                    bxbRegionID: bxbRegionID,
                                }, () => {
                                    jwtClient.get(this.regionsUrl, {params: {region_id: bxbRegionID}})
                                        .then((response) => {
                                            this.setState({
                                                bxbCities: this.sortAddressOptions(response.data),
                                                bxbCity: bxbCity, bxbCityErr: '',
                                                bxbCityID: bxbCityID,
                                            }, () => {
                                                jwtClient.get(this.regionsUrl, {params: {city_id: bxbCityID}})
                                                    .then((response) => {
                                                        this.setState({
                                                            bxbStreets: this.sortAddressOptions(response.data),
                                                            bxbStreet: bxbStreet, bxbStreetErr: '',
                                                            bxbStreetID: bxbStreetID,
                                                            deliverTo: DeliverTo.pickupPoint,
                                                        });
                                                    })
                                                    .catch(err => {
                                                        this.setState({bxbStreetErr: 'failed to load'})
                                                    })
                                            });
                                        })
                                        .catch(err => {
                                            this.setState({bxbCityErr: 'failed to load'})
                                        })
                                });
                            })
                            .catch(err => {
                                this.setState({bxbRegionErr: 'failed to load'})
                            })
                    }
                }
            })
    }

    calcTotal = () => {
        let total = 0;
        let subtotal = 0;
        let i;
        for (i of this.state.items) {
            subtotal = parseFloat((i.price * i.quantity).toFixed(2));
            total += subtotal;
        }
        return total.toFixed(2);
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if (!this.formValid()) {
            window.scrollTo(0, 0)
            return
        }
        this.setState({isSubmitting: true})
        const s = this.state
        const passportIssuedAt = `${s.passportYear}-${String(s.passportMonth).padStart(2, '0')}-${String(s.passportDay).padStart(2, '0')}`;
        let requestBody = {
            customs_declaration: {
                consignee_personal_data: {
                    name: s.name,
                    middlename: s.middlename,
                    surname: s.surname,
                    email: s.email,
                    phone: s.phone,
                    passport_country: s.passportCountry,
                    passport_series: s.passportSeries,
                    passport_number: s.passportNumber,
                    passport_issued_at: passportIssuedAt,
                    passport_issued_by: s.passportIssuedBy,
                    individual_taxpayer_number: s.individualTaxpayerNumber,
                },
                consignee_address: s.deliverTo === DeliverTo.door ? {
                    deliver_to: DeliverTo.door,
                    zip: s.zip,
                    region: s.region,
                    city: s.city,
                    street: s.street,
                    house: s.house,
                    corpus: s.corpus,
                    apartment: s.apartment,
                } : {
                    deliver_to: DeliverTo.pickupPoint,
                    region: {label: s.bxbRegion, value: s.bxbRegionID},
                    city: {label: s.bxbCity, value: s.bxbCityID},
                    street: {label: s.bxbStreet, value: s.bxbStreetID},
                },
                items: s.items.map((v, i) => {
                    return {
                        description: v['description'],
                        quantity: parseInt(v['quantity']),
                        price: parseFloat(v['price']),
                        link: v['link'],
                    }
                }),
            }
        }
        jwtClient.put(`/api/v1/package/${this.props.packageID}/update`, requestBody)
            .then(response => {
                    if (response.status === 200) {
                        window.location.href = '/'
                        return
                    }
                    this.setState({
                        formErr: 'Server error: invalid status code',
                        isSubmitting: false,
                    })
                }
            ).catch(error => {
            if (error.response) {
                this.setState({
                    formErr: `Error: ${JSON.stringify(error.response.data)}`,
                    isSubmitting: false,
                })
            }
        });
    }

    formValid = () => {
        let err = ''
        let errors = {}
        const state = this.state
        let f
        const validate = function (validator, fieldName, fieldValue) {
            err = validateField(validator, fieldName, fieldValue)
            if (err) {
                errors[fieldName + 'Err'] = err
            }
        }

        for (const f of [
            'name', 'surname',
            'email', 'phone',
            'passportYear', 'passportMonth', 'passportDay',
            'passportIssuedBy',
        ]) {
            validate(validatorRU, f, state[f])
        }
        if (state.passportCountry === RUSSIA_CODE) {
            for (const f of [
                'middlename',
                'passportSeries',
                'individualTaxpayerNumber',
            ]) {
                validate(validatorRU, f, state[f])
            }
        }
        f = 'passportNumber'
        err = validateField(validatorRU, f, state[f], state.passportCountry)
        if (err) {
            errors[f + 'Err'] = err
        }

        let itemErrors = []
        let hasItemErrors = false
        for (let i = 0; i < state.items.length; i++) {
            itemErrors[i] = {}
            f = 'link'
            err = validateField(validatorRU, f, state.items[i][f])
            if (err) {
                itemErrors[i][f + 'Err'] = err
                hasItemErrors = true
            }
            f = 'description'
            err = validateField(validatorRU, f, state.items[i][f])
            if (err) {
                itemErrors[i][f + 'Err'] = err
                hasItemErrors = true
            }
            f = 'quantity'
            err = validateField(validatorRU, f, state.items[i][f])
            if (err) {
                itemErrors[i][f + 'Err'] = err
                hasItemErrors = true
            }
            f = 'price'
            err = validateField(validatorRU, f, state.items[i][f])
            if (err) {
                itemErrors[i][f + 'Err'] = err
                hasItemErrors = true
            }
        }

        if (state.deliverTo === DeliverTo.door) {
            for (const f of ['zip', 'region', 'city', 'street', 'house', 'corpus', 'apartment']) {
                validate(validatorRU, f, state[f])
            }
        } else {
            for (const f of ['bxbRegion', 'bxbCity', 'bxbStreet']) {
                validate(validatorRU, f, state[f])
            }
        }

        if (Object.keys(errors).length === 0 && !hasItemErrors) {
            return true
        } else {
            this.setState((prevState) => {
                let items = []
                for (let i = 0; i < prevState.items.length; i++) {
                    items.push({...prevState.items[i], ...itemErrors[i]})
                }
                return {...prevState, ...errors, items: items}
            })
            return false
        }
    }
}

class UpdatePackageUA extends Component {
    constructor(props) {
        super(props);
        const pkg = props.pkg;
        this.state = {
            items: pkg.customs_declaration.items,
            itemErrs: pkg.customs_declaration.items.map((v, i) => {
                let err = {};
                for (const k of Object.keys(v)) {
                    err[k] = '';  // initially empty errors
                }
                return err;
            }),
            formErr: '',
            isSubmitting: false,
        }
    }

    handleChangeItem = (name, value, index) => {
        this.setState((prevState) => {
            let items = [...prevState.items];
            items[index][name] = value;
            let itemErrs = [...prevState.itemErrs];
            itemErrs[index][name] = '';
            return {
                items: items,
                itemErrs: itemErrs,
            }
        })
    }

    handleBlurItem = (name, value, index) => {
        const err = validateField(validatorRU, name, value);
        if (err) {
            this.setState((prevState) => {
                let itemErrs = [...prevState.itemErrs];
                itemErrs[index][name] = err;
                return {
                    itemErrs: itemErrs,
                }
            })
        }
    }

    render() {
        const {items, itemErrs} = this.state;
        return (
            <div>
                <h2 className="mt-3">Update Package "{this.props.pkg.code}"</h2>
                {!!this.state.formErr && <Alert variant="danger">{this.state.formErr}</Alert>}

                <Form onSubmit={this.handleSubmit}>
                    <FormDelimiter text="ITEMS"/>

                    <ol>
                        {this.state.items.map((item, index) => (
                            <li key={index}>
                                <Form.Group>
                                    <Row>
                                        <Col sm="8">
                                            <Input
                                                prependText="Description"
                                                value={items[index].description}
                                                error={itemErrs[index].description}
                                                name="description"
                                                onChange={(e) => {
                                                    this.handleChangeItem(e.target.name, e.target.value, index)
                                                }}
                                                onBlur={(e) => {
                                                    this.handleBlurItem(e.target.name, e.target.value, index)
                                                }}
                                            />
                                            <Form.Text className="text-muted">
                                                Example: Apple iPhone Xs Max 6.5
                                            </Form.Text>
                                        </Col>
                                        <Col sm="4">
                                            <InputGroup>
                                                <InputGroup.Prepend>
                                                    <InputGroup.Text>
                                                        <small>HS</small>
                                                    </InputGroup.Text>
                                                </InputGroup.Prepend>
                                                <Form.Control as="select"
                                                              name="hs_code"
                                                              value={items[index].hs_code}
                                                              onChange={(e) => {
                                                                  this.handleChangeItem(e.target.name, e.target.value, index)
                                                              }}
                                                >
                                                    <option value="68125000">Clothing</option>
                                                    <option value="84733099">Electronics</option>
                                                    <option value="85166000">Home Appliances</option>
                                                    <option value="85369090">Smart Devices</option>
                                                    <option value="33049900">Beauty & Health</option>
                                                    <option value="96050090">Home Products</option>
                                                    <option value="49019900">Printing</option>
                                                    <option value="33061020">Kids Items</option>
                                                    <option value="95059090">Gifts</option>
                                                    <option value="21069099">Food</option>
                                                    <option value="82055990">Tools</option>
                                                    <option value="84314390">Plumbing</option>
                                                    <option value="82019000">Garden</option>
                                                    <option value="95069990">Sport & Hobby</option>
                                                    <option value="62171000">Other</option>
                                                </Form.Control>
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </Form.Group>
                                <Form.Group>
                                    <Row className="mb-5">
                                        <Col sm="4">
                                            <InputGroup>
                                                <Prepend text="Quantity"/>
                                                <Form.Control
                                                    type="number"
                                                    value={item.quantity}
                                                    name="quantity"
                                                    onChange={(e) => {
                                                        this.handleChangeItem(e.target.name, e.target.value, index)
                                                    }}
                                                    onBlur={(e) => {
                                                        this.handleBlurItem(e.target.name, e.target.value, index)
                                                    }}
                                                    onFocus={e => {
                                                        e.target.select()
                                                    }}
                                                    isInvalid={!!itemErrs[index].quantity}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {itemErrs[index].quantity}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Col>
                                        <Col sm="4">
                                            <InputGroup>
                                                <Prepend icon="dollar-sign"/>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={item.price}
                                                    name="price"
                                                    onChange={(e) => {
                                                        this.handleChangeItem(e.target.name, e.target.value, index)
                                                    }}
                                                    onBlur={(e) => {
                                                        this.handleBlurItem(e.target.name, e.target.value, index)
                                                    }}
                                                    onFocus={e => {
                                                        e.target.select()
                                                    }}
                                                    isInvalid={!!itemErrs[index].price}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {itemErrs[index].price}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        </Col>
                                        <Col sm="3">
                                            <InputGroup>
                                                <Prepend text="Subtotal"/>
                                                <Form.Control
                                                    readOnly
                                                    value={(item.price * item.quantity).toFixed(2)}
                                                />
                                            </InputGroup>
                                        </Col>
                                        <Col sm="1">
                                            <Button
                                                title="Delete Item"
                                                disabled={items.length === 1}
                                                className="btn btn-danger"
                                                onClick={_ => {
                                                    this.setState((prevState) => {
                                                        let items = [...prevState.items];
                                                        items.splice(index, 1);
                                                        let itemErrs = [...prevState.itemErrs];
                                                        itemErrs.splice(index, 1);
                                                        return {
                                                            items: items,
                                                            itemErrs: itemErrs,
                                                        }
                                                    })
                                                }}
                                            >
                                                <FontAwesomeIcon icon="trash"/>
                                            </Button>

                                        </Col>
                                    </Row>
                                </Form.Group>
                            </li>
                        ))}
                    </ol>

                    <Form.Group>
                        <Row className="mb-1">
                            <Col sm="8">
                                <Button
                                    className="btn btn-success mr-3"
                                    onClick={_ => {
                                        this.setState((prevState) => {
                                            const nextIndex = prevState.items.length;
                                            let items = [...prevState.items];
                                            items[nextIndex] = {
                                                description: '',
                                                quantity: 1,
                                                price: 0.01,
                                                hs_code: '68125000',
                                            };
                                            let itemErrs = [...prevState.itemErrs];
                                            itemErrs[nextIndex] = {
                                                description: '',
                                                quantity: '',
                                                price: '',
                                                hs_code: '',
                                            };
                                            return {
                                                items: items,
                                                itemErrs: itemErrs,
                                            }
                                        })
                                    }}
                                >
                                    Add Item
                                </Button>

                            </Col>
                            <Col sm="4">
                                <InputGroup>
                                    <Prepend text="Total"/>
                                    <Form.Control
                                        readOnly
                                        value={(_ => {
                                            let total = 0;
                                            let subtotal = 0;
                                            let i;
                                            for (i of items) {
                                                subtotal = parseFloat((i.price * i.quantity).toFixed(2));
                                                total += subtotal;
                                            }
                                            return total.toFixed(2);
                                        })()}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Form.Group>
                    <Form.Group>
                        <Row>
                            <Col sm="2">
                                <Button variant="primary" type="submit" disabled={this.state.isSubmitting}>
                                    Submit
                                </Button>
                            </Col>
                        </Row>
                    </Form.Group>
                </Form>
            </div>
        );
    }


    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({isSubmitting: true});

        for (const i of this.state.items) {
            for (const k in i) {
                if (i[k] === '') {
                    this.setState({
                        formErr: `${k} in items is required`,
                        isSubmitting: false,
                    });
                    return
                }
            }
        }

        for (const err of this.state.itemErrs) {
            for (const k in err) {
                if (err[k] !== '') {
                    this.setState({
                        formErr: `${k} in items has error`,
                        isSubmitting: false,
                    });
                    return
                }
            }
        }

        let customsDeclaration = this.props.pkg.customs_declaration;
        customsDeclaration.items = this.state.items;
        let data = {customs_declaration: customsDeclaration};
        jwtClient.put(`/api/v1/package/${this.props.pkg.id}/update`, data)
            .then(response => {
                    if (response.status === 200) {
                        this.props.history.push(`/package/${this.props.pkg.id}/details`);
                    }
                }
            ).catch(error => {
            if (error.response) {
                this.setStatus({
                    error: `Error: ${error.response}`,
                    isSubmitting: false,
                });
            }
        });
    };
}

